import React from "react";
import { Flex, Image, Heading } from "@chakra-ui/react";
import logo from "../../assets/imgs/logo.png"

type Props = {
  color: string,
  imgSize?: string,
  fontSize?: string
}

export default function Logo({ color, imgSize, fontSize }: Props) {
  return (
    <Flex align="center" justify="center" gap='1'>
      <Image 
        src={logo} 
        boxSize={imgSize ? imgSize : "60px"} 
      />
      <Heading
        fontWeight="black"
        fontStyle="italic"
        mt={1}
        fontFamily="sans-serif"
        fontSize={fontSize ? fontSize : "3xl"}
        color={color}
      >
        eden
      </Heading>
    </Flex>
  );
}